import { withModalProvider } from "../../hoc/withModalProvider";
import { ConfirmationContainer as View, IProps } from "./ConfirmationContainer";

export const ConfirmationContainer = withModalProvider<IProps>(View);
